module.exports = __webpack_public_path__ + "img/warning.c7585f88.gif";